/**
 * Emissions Tracker User Management Route
 *
 * User management within the Emissions Tracker app context.
 */

import { useParams } from 'react-router-dom';
import { UserManagement } from '@routes/user-management';
import { useAppSelector } from '@reducers/index';
import { FeaturePermissions } from '@services/permissions/FeaturePermissions';
import { getRootConfig } from '@selectors/globalData';
import { emissionsTrackerRoutes } from '../routes';
import { EmissionsAdminBreadcrumbs } from '../components/breadcrumbs/EmissionsAdminBreadcrumbs';

export const EmissionsUserManagementRoute = () => {
  const { initiativeId, page } = useParams<{ page?: string; initiativeId: string }>();
  const rootConfig = useAppSelector(getRootConfig);
  const userLimit = FeaturePermissions.getLimitUsers(rootConfig);

  return (
    <UserManagement
      baseRoute={emissionsTrackerRoutes.EMISSIONS_MANAGE_USERS}
      initiativeId={initiativeId}
      page={page}
      userLimit={userLimit}
      BreadcrumbsComponent={EmissionsAdminBreadcrumbs}
    />
  );
};
